import styled from 'styled-components';

export const PayPalLaterMessage = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
`;
